export default {
  computed: {
    /**
      * Check if is sandbox environement
      */
    isSandbox() {
      return (
        location.hostname === 'localhost'
        || location.hostname === '127.0.0.1'
        || location.protocol === 'file:'
      );
    }
  }
};
